import each from 'lodash/each';
import startsWith from 'lodash/startsWith';

export function useMobileNumber() {
    function trimNumber(number) {
        return number.toString()
            .replaceAll(' ','')
            .replaceAll('-','')
            .replaceAll('(','')
            .replaceAll(')','')
            .replaceAll('/', '');
    }

    function isValidNumber (number) {
        let trimmedNumber = trimNumber(number).replace('+', '');
        if (trimmedNumber[0] === '0') {
            return false;
        }
        return /^\d+$/.test(trimmedNumber)
    }

    function hasValidCountryCallingCode (jurisdictionsList, number) {
        number = trimNumber(number);
        let hasValidCountryCallingCode = false;
        each(jurisdictionsList, (jurisdiction) => {
            if (startsWith(number, jurisdiction.callingCode)) {
                hasValidCountryCallingCode = true;
            }
        });
        return hasValidCountryCallingCode;
    }

    return {
        hasValidCountryCallingCode,
        isValidNumber,
        trimNumber
    }
}